// AUTO-GENERATED (dump από aade_nationality_aliases). Mirror του server mapping για το AADE modal check.
// lowercase alias -> alpha3. Κράτα το συγχρονισμένο αν αλλάξει ο πίνακας (re-dump).
export const NATIONALITY_ALIASES: Record<string, string> = {
  "ae": "ARE",
  "al": "ALB",
  "albania": "ALB",
  "algeria": "DZA",
  "am": "ARM",
  "america": "USA",
  "american": "USA",
  "ar": "ARG",
  "argentina": "ARG",
  "armenia": "ARM",
  "at": "AUT",
  "au": "AUS",
  "aus": "AUS",
  "australia": "AUS",
  "australian": "AUS",
  "austria": "AUT",
  "austrian": "AUT",
  "aut": "AUT",
  "az": "AZE",
  "azerbaijan": "AZE",
  "ba": "BIH",
  "bahrain": "BHR",
  "bangladesh": "BGD",
  "bd": "BGD",
  "be": "BEL",
  "bel": "BEL",
  "belarus": "BLR",
  "belgian": "BEL",
  "belgium": "BEL",
  "bg": "BGR",
  "bgr": "BGR",
  "bh": "BHR",
  "bosnia and herzegovina": "BIH",
  "br": "BRA",
  "brazil": "BRA",
  "british": "GBR",
  "bulgaria": "BGR",
  "bulgarian": "BGR",
  "by": "BLR",
  "ca": "CAN",
  "can": "CAN",
  "canada": "CAN",
  "canadian": "CAN",
  "ch": "CHE",
  "che": "CHE",
  "chile": "CHL",
  "china": "CHN",
  "cl": "CHL",
  "cn": "CHN",
  "co": "COL",
  "colombia": "COL",
  "croatia": "HRV",
  "croatian": "HRV",
  "cy": "CYP",
  "cyp": "CYP",
  "cypriot": "CYP",
  "cyprus": "CYP",
  "cz": "CZE",
  "cze": "CZE",
  "czech": "CZE",
  "czechia": "CZE",
  "czech republic": "CZE",
  "danish": "DNK",
  "de": "DEU",
  "denmark": "DNK",
  "deu": "DEU",
  "deutschland": "DEU",
  "dk": "DNK",
  "dnk": "DNK",
  "dutch": "NLD",
  "dz": "DZA",
  "ee": "EST",
  "eg": "EGY",
  "egypt": "EGY",
  "ell": "GRC",
  "england": "GBR",
  "english": "GBR",
  "es": "ESP",
  "esp": "ESP",
  "estonia": "EST",
  "fi": "FIN",
  "fin": "FIN",
  "finland": "FIN",
  "finnish": "FIN",
  "fr": "FRA",
  "fra": "FRA",
  "france": "FRA",
  "french": "FRA",
  "gb": "GBR",
  "gbr": "GBR",
  "ge": "GEO",
  "georgia": "GEO",
  "ger": "DEU",
  "german": "DEU",
  "germany": "DEU",
  "gr": "GRC",
  "grc": "GRC",
  "gre": "GRC",
  "great britain": "GBR",
  "greece": "GRC",
  "greek": "GRC",
  "hellas": "GRC",
  "hellenic": "GRC",
  "hk": "HKG",
  "holland": "NLD",
  "hong kong": "HKG",
  "hr": "HRV",
  "hrv": "HRV",
  "hu": "HUN",
  "hun": "HUN",
  "hungarian": "HUN",
  "hungary": "HUN",
  "iceland": "ISL",
  "id": "IDN",
  "ie": "IRL",
  "il": "ISR",
  "in": "IND",
  "india": "IND",
  "indonesia": "IDN",
  "iq": "IRQ",
  "ir": "IRN",
  "iran": "IRN",
  "iraq": "IRQ",
  "ireland": "IRL",
  "irish": "IRL",
  "irl": "IRL",
  "is": "ISL",
  "isr": "ISR",
  "israel": "ISR",
  "israeli": "ISR",
  "it": "ITA",
  "ita": "ITA",
  "italia": "ITA",
  "italian": "ITA",
  "italy": "ITA",
  "japan": "JPN",
  "jo": "JOR",
  "jordan": "JOR",
  "jp": "JPN",
  "kazakhstan": "KAZ",
  "ke": "KEN",
  "kenya": "KEN",
  "kosovo": "XKX",
  "kr": "KOR",
  "kuwait": "KWT",
  "kw": "KWT",
  "kz": "KAZ",
  "latvia": "LVA",
  "lb": "LBN",
  "lebanon": "LBN",
  "libya": "LBY",
  "lithuania": "LTU",
  "lt": "LTU",
  "lu": "LUX",
  "lux": "LUX",
  "luxembourg": "LUX",
  "lv": "LVA",
  "ly": "LBY",
  "ma": "MAR",
  "malaysia": "MYS",
  "malta": "MLT",
  "maltese": "MLT",
  "md": "MDA",
  "me": "MNE",
  "mexico": "MEX",
  "mk": "MKD",
  "mlt": "MLT",
  "moldova": "MDA",
  "montenegro": "MNE",
  "morocco": "MAR",
  "mt": "MLT",
  "mx": "MEX",
  "my": "MYS",
  "netherlands": "NLD",
  "new zealand": "NZL",
  "ng": "NGA",
  "nigeria": "NGA",
  "nl": "NLD",
  "nld": "NLD",
  "no": "NOR",
  "nor": "NOR",
  "north macedonia": "MKD",
  "norway": "NOR",
  "norwegian": "NOR",
  "nz": "NZL",
  "om": "OMN",
  "oman": "OMN",
  "pakistan": "PAK",
  "pe": "PER",
  "peru": "PER",
  "ph": "PHL",
  "philippines": "PHL",
  "pk": "PAK",
  "pl": "POL",
  "pol": "POL",
  "poland": "POL",
  "polish": "POL",
  "portugal": "PRT",
  "portuguese": "PRT",
  "prt": "PRT",
  "pt": "PRT",
  "qa": "QAT",
  "qatar": "QAT",
  "ro": "ROU",
  "romania": "ROU",
  "romanian": "ROU",
  "rou": "ROU",
  "rs": "SRB",
  "ru": "RUS",
  "rus": "RUS",
  "russia": "RUS",
  "russian": "RUS",
  "sa": "SAU",
  "saudi arabia": "SAU",
  "scotland": "GBR",
  "se": "SWE",
  "serbia": "SRB",
  "serbian": "SRB",
  "sg": "SGP",
  "si": "SVN",
  "singapore": "SGP",
  "sk": "SVK",
  "slovak": "SVK",
  "slovakia": "SVK",
  "slovenia": "SVN",
  "slovenian": "SVN",
  "south africa": "ZAF",
  "south korea": "KOR",
  "spain": "ESP",
  "spanish": "ESP",
  "srb": "SRB",
  "svk": "SVK",
  "svn": "SVN",
  "swe": "SWE",
  "sweden": "SWE",
  "swedish": "SWE",
  "swiss": "CHE",
  "switzerland": "CHE",
  "sy": "SYR",
  "syria": "SYR",
  "taiwan": "TWN",
  "th": "THA",
  "thailand": "THA",
  "the netherlands": "NLD",
  "tn": "TUN",
  "tr": "TUR",
  "tunisia": "TUN",
  "tur": "TUR",
  "turkey": "TUR",
  "turkish": "TUR",
  "tw": "TWN",
  "ua": "UKR",
  "uk": "GBR",
  "ukr": "UKR",
  "ukraine": "UKR",
  "ukrainian": "UKR",
  "united arab emirates": "ARE",
  "united kingdom": "GBR",
  "united states": "USA",
  "united states of america": "USA",
  "unknown / stateless": "XXX",
  "uruguay": "URY",
  "us": "USA",
  "u.s.a.": "USA",
  "usa": "USA",
  "uy": "URY",
  "ve": "VEN",
  "venezuela": "VEN",
  "vietnam": "VNM",
  "vn": "VNM",
  "wales": "GBR",
  "xk": "XKX",
  "xxx": "XXX",
  "za": "ZAF",
  "αγγλική": "GBR",
  "άγγλος": "GBR",
  "άγνωστη / ανιθαγενής": "XXX",
  "αζερμπαϊτζάν": "AZE",
  "αίγυπτος": "EGY",
  "αλβανία": "ALB",
  "αλγερία": "DZA",
  "αμερικανός": "USA",
  "αμερική": "USA",
  "αργεντινή": "ARG",
  "αρμενία": "ARM",
  "αυστραλία": "AUS",
  "αυστρία": "AUT",
  "αυστριακός": "AUT",
  "βέλγιο": "BEL",
  "βέλγος": "BEL",
  "βενεζουέλα": "VEN",
  "βιετνάμ": "VNM",
  "βόρεια μακεδονία": "MKD",
  "βοσνία-ερζεγοβίνη": "BIH",
  "βουλγαρία": "BGR",
  "βραζιλία": "BRA",
  "βρετανία": "GBR",
  "βρετανική": "GBR",
  "βρετανός": "GBR",
  "γαλλία": "FRA",
  "γαλλική": "FRA",
  "γάλλος": "FRA",
  "γερμανία": "DEU",
  "γερμανική": "DEU",
  "γερμανός": "DEU",
  "γεωργία": "GEO",
  "δανία": "DNK",
  "ελβετία": "CHE",
  "ελβετός": "CHE",
  "ελλαδα": "GRC",
  "ελλάδα": "GRC",
  "ελλην": "GRC",
  "ελληνας": "GRC",
  "έλληνας": "GRC",
  "ελληνιδα": "GRC",
  "ελληνίδα": "GRC",
  "ελληνικα": "GRC",
  "ελληνικη": "GRC",
  "ελληνική": "GRC",
  "εσθονία": "EST",
  "ηνωμένα αραβικά εμιράτα": "ARE",
  "ηνωμένες πολιτείες": "USA",
  "ηνωμένο βασίλειο": "GBR",
  "ηπα": "USA",
  "ιαπωνία": "JPN",
  "ινδία": "IND",
  "ινδονησία": "IDN",
  "ιορδανία": "JOR",
  "ιράκ": "IRQ",
  "ιράν": "IRN",
  "ιρλανδία": "IRL",
  "ισλανδία": "ISL",
  "ισπανία": "ESP",
  "ισπανός": "ESP",
  "ισραήλ": "ISR",
  "ιταλία": "ITA",
  "ιταλική": "ITA",
  "ιταλός": "ITA",
  "καζακστάν": "KAZ",
  "καναδάς": "CAN",
  "κατάρ": "QAT",
  "κένυα": "KEN",
  "κίνα": "CHN",
  "κολομβία": "COL",
  "κόσοβο": "XKX",
  "κουβέιτ": "KWT",
  "κροατία": "HRV",
  "κύπριος": "CYP",
  "κύπρος": "CYP",
  "λετονία": "LVA",
  "λευκορωσία": "BLR",
  "λίβανος": "LBN",
  "λιβύη": "LBY",
  "λιθουανία": "LTU",
  "λουξεμβούργο": "LUX",
  "μαλαισία": "MYS",
  "μάλτα": "MLT",
  "μαρόκο": "MAR",
  "μαυροβούνιο": "MNE",
  "μεξικό": "MEX",
  "μολδαβία": "MDA",
  "μπαγκλαντές": "BGD",
  "μπαχρέιν": "BHR",
  "νέα ζηλανδία": "NZL",
  "νιγηρία": "NGA",
  "νορβηγία": "NOR",
  "νότια αφρική": "ZAF",
  "νότια κορέα": "KOR",
  "ολλανδία": "NLD",
  "ολλανδός": "NLD",
  "ομάν": "OMN",
  "ουγγαρία": "HUN",
  "ουκρανία": "UKR",
  "ουρουγουάη": "URY",
  "πακιστάν": "PAK",
  "περού": "PER",
  "πολωνία": "POL",
  "πορτογαλία": "PRT",
  "πορτογάλος": "PRT",
  "ρουμανία": "ROU",
  "ρωσία": "RUS",
  "ρώσος": "RUS",
  "σαουδική αραβία": "SAU",
  "σερβία": "SRB",
  "σιγκαπούρη": "SGP",
  "σλοβακία": "SVK",
  "σλοβενία": "SVN",
  "σουηδία": "SWE",
  "σουηδός": "SWE",
  "συρία": "SYR",
  "ταϊβάν": "TWN",
  "ταϊλάνδη": "THA",
  "τουρκία": "TUR",
  "τσεχία": "CZE",
  "τυνησία": "TUN",
  "φιλιππίνες": "PHL",
  "φινλανδία": "FIN",
  "χιλή": "CHL",
  "χονγκ κονγκ": "HKG",
};

/* ═══ 6.480 — ΧΕΙΡΟΚΙΝΗΤΑ ALIASES ═══
   ΔΕΝ είναι μέρος του dump. Είναι ενδώνυμα (πώς λέει ο καθένας τη δική του
   εθνικότητα στη γλώσσα του) που εμφανίζονται σε crew lists από ξένα πρακτορεία.
   ΜΕΤΑ το auto-generated object ώστε ένα re-dump να μην τα σβήσει — αν ξαναγίνει
   dump, κράτα αυτό το μπλοκ. Το Object.assign γράφει ΜΟΝΟ ό,τι λείπει. */
const MANUAL_ALIASES: Record<string, string> = {
  'deutsch': 'DEU', 'deutsche': 'DEU', 'deutscher': 'DEU',
  'belgisch': 'BEL', 'belge': 'BEL', 'belgische': 'BEL',
  'nederlands': 'NLD', 'nederlandse': 'NLD', 'dutch': 'NLD', 'hollands': 'NLD',
  'italiano': 'ITA', 'italiana': 'ITA',
  'français': 'FRA', 'francais': 'FRA', 'française': 'FRA', 'francaise': 'FRA',
  'español': 'ESP', 'espanol': 'ESP', 'española': 'ESP', 'espanola': 'ESP',
  'polski': 'POL', 'polska': 'POL', 'polskie': 'POL',
  'ελληνική': 'GRC', 'ελληνικη': 'GRC', 'έλληνας': 'GRC', 'ελληνας': 'GRC',
  'ελληνίδα': 'GRC', 'ελληνιδα': 'GRC',
};
for (const k of Object.keys(MANUAL_ALIASES)) {
  if (!NATIONALITY_ALIASES[k]) NATIONALITY_ALIASES[k] = MANUAL_ALIASES[k];
}

// Επιστρέφει alpha3 ή 'XXX' αν δεν αναγνωρίζεται — ΙΔΙΑ λογική με lookupNationality (server).
export function nationalityToIso3(text: string | undefined | null): string {
  const k = String(text ?? '').trim().toLowerCase();
  if (!k) return 'XXX';
  return NATIONALITY_ALIASES[k] || 'XXX';
}
